module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAARUlEQVQoFZXBAREAMBCDMPAvusPB3xL5JJ/ksBBD5LAQQ+SwEEPksBBD5LAQQ+SwEEPksBBD5LAQQ+SwEEPksBBD5JN8eiCTKA+o94lPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/number_context_01.png
// module id = 223
// module chunks = 0